<script setup lang="ts">
import Swal from "sweetalert2";

const userStore: any = useUserStore();
const config = useRuntimeConfig()

const setPin = ref(['', '', '', '', '', '']);
const conformPin = ref(['', '', '', '', '', '']);
const setPinStep = ref(1);
const loading = ref(false);


const handlesetPinInput = async(index: number) =>{
  const nextIndex = index + 1;
  if (nextIndex < setPin.value.length) {
    const nextInput = document.getElementById(`setPin${nextIndex}`);
    // console.log(nextInput)
    if (nextInput) {
      nextInput.focus();
    }
  }
}

const handleBackspacesetPin = (index: number) => {
  if (setPin.value[index] === '' && index > 0) {
    const prevIndex = index - 1;
    setPin.value[prevIndex] = '';
    const nextInput = document.getElementById(`setPin${prevIndex}`);
    console.log(nextInput)
    if (nextInput) {
      nextInput.focus();
    }
  } else if (setPin.value[index] !== '') {
    setPin.value[index] = '';
  }
};



const handleConfirmPinInput = async(index: number) =>{
  const nextIndex = index + 1;
  if (nextIndex < conformPin.value.length) {
    const nextInput = document.getElementById(`confirmPin${nextIndex}`);
    // console.log(nextInput)
    if (nextInput) {
      nextInput.focus();
    }
  }
}

const handleBackspaceConfirmPin = (index: number) => {
  if (conformPin.value[index] === '' && index > 0) {
    const prevIndex = index - 1;
    conformPin.value[prevIndex] = '';
    const nextInput = document.getElementById(`confirmPin${prevIndex}`);
    console.log(nextInput)
    if (nextInput) {
      nextInput.focus();
    }
  } else if (conformPin.value[index] !== '') {
    conformPin.value[index] = '';
  }
};

onMounted(() => {
  document.getElementById('setPin0')?.focus();
  // focusSearch();
});

const nextStep = async() => {
  if (setPin.value.join('').length < 6) {
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: 'PIN harus 6 digit',
    });
    return;
  }
  setPinStep.value = 2;
  document.getElementById('confirmPin0')?.focus();
}

const settingPin = async() => {
  try {
    loading.value = true;
    if (conformPin.value.join('') !== setPin.value.join('')) {
        Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'PIN tidak sama',
        });
        return;
    }
    
    const response = await userStore.setPin(setPin.value.join(''),conformPin.value.join(''));

    if (response.status.code === 200) {
        Swal.fire({
            icon: 'success',
            title: 'Berhasil',
            text: 'PIN berhasil diubah',
        });
        localStorage.setItem(`isPinSet${userStore.user?.id}`, true);
        setPinStep.value = 1;
        setPin.value = ['', '', '', '', '', ''];
        conformPin.value = ['', '', '', '', '', ''];
        document.getElementById('setPin0')?.focus();
        document.getElementById('closeResetPin')?.click();

        // Close the modal using Bootstrap
        const modal = document.getElementById('settingPinModal');
        if (modal) {
            const modalInstance = bootstrap.Modal.getInstance(modal);
            if (modalInstance) {
                modalInstance.hide();
            }
        }

    } else {
        setPin.value = ['', '', '', '', '', ''];
        conformPin.value = ['', '', '', '', '', ''];
        document.getElementById('setPin0')?.focus();
        Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: response.data.message,
        });
    }
  } catch (error) {
    Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Terjadi kesalahan, silahkan coba lagi',
    })
  }finally{
    loading.value = false;
  }
}

</script>

<template>
<div>
    <div class="modal fade" id="settingPinModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body rounded">
            <div class="myform modal-body">
              <div class="text-center">
                <img
                  
                  :src="`${config.public.logo}`"
                  width="75%"
                  alt=""
                />
                <h6 class="mt-3 mb-3">Demi meningkatkan keamanan pembayaran transaksi, kami sarankan agar Anda memiliki PIN</h6>
              </div>
              <div class="form">

              <div class="mb-3">
                <section class="wrapper">
                  <div class="container">
                    <div class="otp_input text-center mb-2">
                      <label for="otp" class="form-label fw-bolder"
                        >{{ setPinStep == 1 ? 'Masukan PIN': "Masukan Ulang PIN" }}</label
                      >

                      <form v-if="setPinStep == 1" @submit.prevent="nextStep">
                        <div class="d-flex align-items-center justify-content-between">
                          <input
                            v-if="setPinStep == 1"
                            v-for="(digit, index) in setPin"
                            :key="index"
                            v-model="setPin[index]"
                            @input="handlesetPinInput(index)"
                            @keydown.backspace.prevent="handleBackspacesetPin(index)"
                            type="password"
                            :id="`setPin${index}`"
                            class="form-control-otp"
                            placeholder=""
                            maxlength="1"
                          />
                        </div>
                        <button class="btn btn-primary border-2 rounded-3 mt-3 fw-medium w-100" type="submit" :disabled="loading">
                          <label class="spinner-border" role="status" v-if="loading">
                            <span class="visually-hidden">Loading...</span>
                          </label>
                          Lanjutkan Proses
                        </button>
                      </form>
                      
                      <form v-if="setPinStep == 2" @submit.prevent="settingPin">
                        <div class="d-flex align-items-center justify-content-between">
                          <input
                            v-if="setPinStep == 2"
                            v-for="(digit, index) in conformPin"
                            :key="index"
                            v-model="conformPin[index]"
                            @input="handleConfirmPinInput(index)"
                            @keydown.backspace.prevent="handleBackspaceConfirmPin(index)"
                            type="password"
                            :id="`confirmPin${index}`"
                            class="form-control-otp"
                            placeholder=""
                            maxlength="1"
                          />
                        </div>
                        <button class="btn btn-primary border-2 rounded-3 mt-3 fw-medium w-100" type="submit" :disabled="loading">
                          <label class="spinner-border" role="status" v-if="loading">
                            <span class="visually-hidden">Loading...</span>
                          </label>
                          Lanjutkan Proses
                        </button>
                      </form>
                      <div  class="d-flex align-items-center justify-content-between mt-2" >
                      </div>
                      </div>
                    </div>
                </section>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>    
</template>

<style scoped>
/* .modal-content {
  width: 80%;
  margin: 0 auto;
}
.modal-body {
  padding: 0;
}
.btn-close {
  position: absolute;
  right: 0;
  padding: 1em;
} */
.myform {
  padding: 2em;
  max-width: 100%;
  color: #114777;
}
.myform .form-control {
  background-color: inherit;
  color: #114777;
  padding-left: 0;
  border: 0;
  border-radius: 0;
  border-bottom: 1px solid #114777;
}
.form-control::placeholder {
  color: #114777;
  font-size: 14px;
}
@media (max-width: 576px) {
  .myform {
    max-width: 90%;
    margin: 0 auto;
  }
}
.form-control:focus {
  box-shadow: inset 0 -1px 0 #7e7e7e;
}
.form-control {
  background-color: inherit;
  color: #114777;
  padding-left: 0;
  border: 0;
  border-radius: 0;
  border-bottom: 1px solid #114777;
}


/* Main CSS OTP Verification New Changing */
.wrapper {
  background-position: bottom center;
  background-repeat: no-repeat;
  background-size: contain;
  background-attachment: fixed;
  min-height: 100%;
}
.wrapper .logo img {
  max-width: 40%;
}
.wrapper input {
  background-color: #f0f0f0;
  border: 0;
  border-color: #f0f0f0;
  border-radius: 6px;
  color: var(--gray);
}
.wrapper input:focus {
  box-shadow: none;
}


.wrapper .otp_input input {
  width: 14%;
  height: 50px;
  text-align: center;
  font-size: 20px;
  font-weight: 600;
}

@media (max-width: 1200px) {
  .wrapper .otp_input input {
    height: 50px;
  }
}
@media (max-width: 767px) {
  .wrapper .otp_input input {
    height: 40px;
  }
}
</style>